import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const QuestionAnswerIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "QuestionAnswer",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M24.16 13.38h2.94c1.6.01 2.9 1.32 2.9 2.92v4.62c0 1.6-1.29 2.9-2.9 2.91h-.06v1.63c0 1.06-.85 1.92-1.91 1.92-.54 0-1.02-.22-1.36-.58s-2.68-2.98-2.68-2.98h-3.34a2.91 2.91 0 0 1-2.89-2.91v-1.32h-.37l-5.2 5.66c-.22.23-.53.37-.87.38-.18 0-.34-.04-.5-.1-.47-.2-.79-.66-.79-1.19V19.6H4.97a3.007 3.007 0 0 1-2.98-3.01V7.64c0-1.66 1.33-3 2.98-3.02h16.2c1.65.01 2.98 1.36 2.98 3.01v5.73Zm0 2.34v.88c0 1.66-1.33 3-2.98 3.02h-4.02v1.31c0 .32.25.58.56.59h4.38l2.65 2.84v-2.85h2.4c.31-.01.56-.27.56-.59v-4.63c0-.31-.25-.57-.56-.58h-2.99Zm-7.52-6.21v-.07c0-.44-.1-.85-.29-1.21-.18-.34-.43-.63-.74-.86-.3-.23-.65-.41-1.04-.51h-.02c-.35-.1-.76-.16-1.18-.16h-.02c-.45 0-.87.07-1.28.19h.03c-.41.12-.77.32-1.08.57-.32.25-.58.57-.77.93v.02c-.21.39-.35.84-.39 1.32s2.22.25 2.22.25c.02-.33.14-.63.33-.88.19-.24.49-.4.82-.4h.11c.27 0 .51.1.69.27.17.17.28.41.28.67v.06c0 .2-.07.39-.18.55-.12.16-.25.3-.4.43s-.46.44-.46.44q-.255.225-.48.45-.18.21-.33.45c-.09.17-.16.34-.21.53-.04.2-.07.43-.07.65v.54h2.18v-.75c.03-.11.07-.21.13-.3.06-.11.14-.2.23-.28l.38-.32c.25-.18.45-.37.65-.54q.285-.24.48-.54c.13-.19.24-.4.31-.63v-.02c.08-.23.12-.49.12-.76v-.08Zm-2.05 6.19c0-.19-.04-.36-.11-.52s-.17-.3-.29-.41a1.4 1.4 0 0 0-.43-.28c-.15-.07-.32-.11-.51-.11h-.02c-.19 0-.38.04-.54.11-.17.07-.31.16-.44.28a1.31 1.31 0 0 0-.4.94c0 .19.04.37.12.53.08.15.18.29.31.41.12.12.26.21.42.28.16.06.34.1.52.1h.07c.37 0 .7-.15.94-.39.21-.22.34-.53.34-.86v-.09Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M11.52 17c-.76 0-1.38-.62-1.38-1.38s.62-1.38 1.38-1.38 1.38.62 1.38 1.38S12.28 17 11.52 17M11.55 12.43c-.63 0-1.14-.51-1.14-1.14 0-1.47.98-2.25 1.7-2.82.65-.52.84-.72.84-1.05 0-.46-.7-.71-1.4-.71s-1.31.36-1.46.83c-.19.6-.82.95-1.43.75-.6-.19-.94-.83-.75-1.43.44-1.44 1.94-2.44 3.64-2.44 2.13 0 3.68 1.26 3.68 2.99 0 1.49-.99 2.27-1.71 2.84-.64.51-.83.71-.83 1.03 0 .63-.51 1.14-1.14 1.14Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1 27.28c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V3.29A3.45 3.45 0 0 1 3.29-.14h17.14c1.89 0 3.43 1.54 3.43 3.43v14.86c0 1.89-1.54 3.43-3.43 3.43H7.19l-5.38 5.38c-.22.22-.51.33-.81.33ZM3.29 2.14c-.63 0-1.14.51-1.14 1.14v20.1l3.76-3.76c.21-.21.51-.33.81-.33h13.71c.63 0 1.14-.51 1.14-1.14V3.29c0-.63-.51-1.14-1.14-1.14H3.29Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 31.86c-.3 0-.59-.12-.81-.33l-5.38-5.38H11.28a1.14 1.14 0 1 1 0-2.28h13.71c.3 0 .59.12.81.33l3.76 3.76V11.29c0-.63-.51-1.14-1.14-1.14h-1.14a1.14 1.14 0 1 1 0-2.28h1.14c1.89 0 3.43 1.54 3.43 3.43v19.43a1.154 1.154 0 0 1-1.15 1.15Z"
      })]
    })
  }));
};
QuestionAnswerIcon.displayName = 'QuestionAnswerIcon';